import importView from '../../views/repayment/repaymen-import.vue';
import createView from '../../components/repayment/single-import-plan-create.vue';
import queryList from '../../views/repayment/repaymen-query-list.vue';
import detailsView from '../../views/repayment/repayment-details.vue';
var repayment = [
    {
        name: 'repaymentImport',
        path: 'import',
        component: importView,
        children: [
            {
                name: 'repaymentCreate',
                path: 'create',
                component: createView,
            },
        ],
    },
    {
        name: 'repaymentQuery',
        path: 'query-list',
        component: queryList,
    },
    {
        name: 'repaymentDetails',
        path: 'details',
        component: detailsView,
    },
];
export default repayment;
